import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, CodeField, NumberField, Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { Schema } from './schema'
import { SingleAdViewTimeSoftValidator } from './SingleAdViewTimeSoftValidator'

export const MultianchorSection = (): JSX.Element => {
  const ability = useAbility()
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.richPlacements.multianchor',
  })

  const { control } = useFormContext<Schema>()

  const cannotUpdate: boolean = ability.cannot(
    'update',
    'GlobalSetupFeature-defaults-richPlacements',
  )

  return (
    <>
      <Paper
        data-cy='section-multianchor'
        sx={{ mt: 0 }}
      >
        <SectionHeader
          subtitle={t('description')}
          title={t('title')}
        />
      </Paper>

      <Paper data-cy='section-basic-settings'>
        <SectionHeader
          subtitle={t('basicSettings.subtitle')}
          title={t('basicSettings.title')}
        />

        <GapBox />

        <BoxForm>
          <NumberField
            control={control}
            disabled={cannotUpdate}
            helperText={<SingleAdViewTimeSoftValidator />}
            label={t('basicSettings.singleAdViewTime.label')}
            name='singleAdViewTime'
            tooltip={{ content: t('basicSettings.singleAdViewTime.tooltip') }}
            width='md'
          />
          <Switch
            control={control}
            disabled={cannotUpdate}
            label={t('basicSettings.displayAfterUserInteraction.label')}
            labelPlacement='start'
            name='displayAfterUserInteraction'
            tooltip={{ content: t('basicSettings.displayAfterUserInteraction.tooltip') }}
          />
        </BoxForm>
      </Paper>

      <Paper data-cy='section-appearance'>
        <SectionHeader
          subtitle={t('appearance.subtitle')}
          title={t('appearance.title')}
        />

        <GapBox />

        <BoxForm>
          <Switch
            control={control}
            disabled={cannotUpdate}
            label={t('appearance.showCloseButton.label')}
            labelPlacement='start'
            name='showCloseButton'
            tooltip={{ content: t('appearance.showCloseButton.tooltip') }}
          />
          <Switch
            control={control}
            disabled={cannotUpdate}
            label={t('appearance.fullWidthMode.label')}
            labelPlacement='start'
            name='fullWidthMode'
            tooltip={{ content: t('appearance.fullWidthMode.tooltip') }}
          />
          <CodeField
            control={control}
            disabled={cannotUpdate}
            language='javascript'
            name='customStyling'
            title={t('appearance.customStyling.label')}
            tooltip={{ content: t('appearance.customStyling.tooltip') }}
          />
        </BoxForm>
      </Paper>
    </>
  )
}
